import React, { useContext, useEffect, useState } from 'react'
import LoadingSpinner from '../../Loader/load';
import { UserContext } from '../../../contexts/userProvider';
import HistoricoCliente from '../../Faturamento/HistoricoCliente';
import Geral from './Types/geral';
import Financeiro from './Types/financeiro';
import Comercial from './Types/comercial';
import Tecnica from './Types/tecnica';
import Patrimonios from './Types/patrimonios';
import Contratos from './Types/contratos';
import Itens from './Types/itens';
import { BiX } from "react-icons/bi";
import Observacoes from './Types/observacoes';
import TabNavigation from '../../General/TabNavigation';

const Visualizar = (props) => {
    const { isGerente } = useContext(UserContext);
    const [client, setClient] = useState(null);
    const [activeTab, setActiveTab] = useState('geral');
    const { cliente, closeModal } = props;

    useEffect(() => {
        let newCliente = cliente ? cliente : {};
        setClient({ ...newCliente });
    }, [cliente])

    const handleFecharClick = () => {
        closeModal();
        setClient(null);
    }

    const tabs = [
        {
            key: 'geral',
            label: 'Geral',
            icon: 'config',
            content: <Geral client={client} setClient={setClient} handleFecharClick={handleFecharClick} />
        },
        {
            key: 'financeiro',
            label: 'Financeiro',
            icon: 'chart',
            content: <Financeiro client={client} setClient={setClient} handleFecharClick={handleFecharClick} />
        },
        {
            key: 'comercial',
            label: 'Comercial',
            icon: 'building',
            content: <Comercial client={client} setClient={setClient} handleFecharClick={handleFecharClick} />
        },
        {
            key: 'técnica',
            label: 'Técnica',
            icon: 'config',
            content: <Tecnica client={client} setClient={setClient} handleFecharClick={handleFecharClick} />
        },
        {
            key: 'patrimônios',
            label: 'Patrimônios',
            icon: 'folder',
            content: <Patrimonios client={client} setClient={setClient} handleFecharClick={handleFecharClick} />
        },
        {
            key: 'contratos',
            label: 'Contratos',
            icon: 'folder',
            content: <Contratos client={client} />
        },
        // Itens — restrito a gerente+ (nível 2 e 3), decisão de 15/set.
        ...(isGerente ? [{
            key: 'itens',
            label: 'Itens',
            icon: 'layer',
            content: <Itens client={client} setClient={setClient} handleFecharClick={handleFecharClick} />
        }] : []),
        {
            key: 'observacoes',
            label: 'Observações',
            icon: 'config',
            content: <Observacoes client={client} setClient={setClient} handleFecharClick={handleFecharClick} />
        },
        // Histórico de faturamento — restrito a gerente+ (nível 2 e 3).
        ...(isGerente ? [{
            key: 'faturamento',
            label: 'Faturamento',
            icon: 'file',
            content: <HistoricoCliente idCliente={client?.id} clienteNome={client?.nome} />
        }] : [])
    ];

    return (
        <div className='fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4'>
            <div className='bg-white dark:bg-gray-800 rounded-3xl shadow-2xl w-full max-w-7xl h-[90vh] flex flex-col relative'>
                {/* Header com botão de fechar */}
                <div className='absolute top-4 right-4 z-10'>
                    <button 
                        onClick={() => closeModal()} 
                        className='p-2 text-gray-500 hover:text-red-500 dark:text-gray-400 dark:hover:text-red-400 transition-colors duration-200 rounded-full hover:bg-gray-100 dark:hover:bg-gray-700'
                        aria-label="Fechar modal"
                    >
                        <BiX className='w-8 h-8' />
                    </button>
                </div>

                {/* Header com gradiente e título - Fixo */}
                <div className='bg-gradient-to-r from-vox-blue-600 to-vox-blue-800 px-6 py-6 rounded-t-3xl flex-shrink-0'>
                    <h1 className='text-2xl font-bold text-white mb-4 flex items-center'>
                        <span className="mr-2">👤</span>
                        Dados do Cliente
                    </h1>
                </div>
                
                {/* Conteúdo principal com TabNavigation - Scrollável */}
                <div className='flex-1 overflow-auto bg-gray-50 dark:bg-gray-900 rounded-b-3xl'>
                    {!client ? (
                        <div className="flex items-center justify-center min-h-64">
                            <LoadingSpinner />
                        </div>
                    ) : (
                        <div className="animate-fade-in h-full">
                            <TabNavigation
                                tabs={tabs}
                                activeTab={activeTab}
                                onTabChange={setActiveTab}
                                variant="minimal"
                                className="h-full"
                            />
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}

export default Visualizar
